import React from "react"
import LookbookThumbCard from "@components/productcards/LookbookThumbCard"
import { lookbooks } from "@staticdata/lookbook-static-data"


const LookbookMenu = ({ handleLookbookMenu }) => {

	return (
		<React.Fragment>
			<div
				className="w-auto lg:w-full bg-white absolute z-[49]"
				onMouseLeave={() => handleLookbookMenu(false)}
			>
				<div className="hidden lg:grid grid-cols-1 lg:grid-cols-2 max-w-[1440px] px-4 xl:px-40 lg:px-10 py-12 h-max lg:h-auto overflow-y-auto mx-auto">
					<div className="grid grid-flow-col gap-x-4 pt-6 lg:pt-0 justify-center lg:justify-start">
						{lookbooks.map((item, index) => (
							<LookbookThumbCard
								key={`lbcard-thumb-${index}`}
								data={item}
								className="relative w-full lg:w-[300px] h-[220px] md:h-auto overflow-hidden cursor-pointer"
							/>
						))}
					</div>
				</div>
			</div>
		</React.Fragment>
	)
}

export default LookbookMenu
